import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { SystemInfo,EventMonitoring } from '../models/trace.model';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private lastEventRoute = '/V1/Tracking/LastEvent/'; // Use environment URL
  private ticketRoute = '/V1/Tracking/Ticket/'; // Use environment URL
  private searchRoute = '/V1/Tracking/SearchEvents'; // Use environment URL
  private eventIdRoute = '/V1/Tracking/Event/'; // Use environment URL
  private eventsRoute = '/V1/Tracking/Events'; // Use environment URL
  private targetSystemRoute = '/V1/Tracking/TargetSystems'; // Use environment URL
  private sourceSystemRoute = '/V1/Tracking/SourceSystems'; // Use environment URL
  private eventsWithSystemsRoute = '/V1/Tracking/EventSystems'; // Use environment URL
  private errorsCountRoute = '/V1/Tracking/ErrorsCount'; // Use environment URL
  private upsertEventRoute = '/V1/Tracking/Event/UpsertEvent'; // Use environment URL
  constructor(private http: HttpClient) {}

  getData(eventName:string | null, masterCode: string | null): Observable<any> {
    if (eventName !== null && masterCode !== null) {
      const url = `${environment.apiConfig.api}${this.lastEventRoute}${encodeURIComponent(eventName)}/MasterCode/${encodeURIComponent(masterCode)}`;
      return this.http.get<any>(url).pipe(
        catchError(this.handleError)
      );
    } else {
      return EMPTY;
    }
  }

  getDataById(eventId:string): Observable<any> {
    if (eventId !== null) {
      const url = `${environment.apiConfig.api}${this.eventIdRoute}${encodeURIComponent(eventId)}`;
      return this.http.get<any>(url).pipe(
        catchError(this.handleError)
      );
    } else {
      return EMPTY;
    }
  }

  getAllEvents(): Observable<EventMonitoring[]> {   
    const url = `${environment.apiConfig.api}${this.eventsRoute}`;
    return this.http.get<EventMonitoring[]>(url).pipe(
      catchError(this.handleError)
    );
  }
  
  getAllEventsWithSystems(): Observable<EventMonitoring[]> {   
    const url = `${environment.apiConfig.api}${this.eventsWithSystemsRoute}`;
    return this.http.get<EventMonitoring[]>(url).pipe(
      catchError(this.handleError)
    );
  }

  getTargetSystem(): Observable<SystemInfo[]> {   
    const url = `${environment.apiConfig.api}${this.targetSystemRoute}`;
    return this.http.get<SystemInfo[]>(url).pipe(
      catchError(this.handleError)
    );
  }

  getSourceSystem(): Observable<SystemInfo[]> {   
    const url = `${environment.apiConfig.api}${this.sourceSystemRoute}`;
    return this.http.get<SystemInfo[]>(url).pipe(
      catchError(this.handleError)
    );
  }

  // POST request method
  sendTicket(body: any): Observable<any> {
    const url = `${environment.apiConfig.api}${this.ticketRoute}`;
    return this.http.post(url, body);
  }

  private handleError(error: HttpErrorResponse) {
    // Handle different types of errors
    let errorDetails = '';

      // A client-side or network error occurred
      errorDetails = error.error.details;


    // Return a user-friendly error message or rethrow the error
    return throwError(() => new Error(errorDetails));
  }

  searchTraces(eventName: string | null, masterCode: string | null, severityLevel: string | null, sourceSystem: string | null, targetSystem: string | null): Observable<any> {
   
    const url = `${environment.apiConfig.api}${this.searchRoute}`;

    let params = new HttpParams();

    if (eventName !== null) {
      params = params.set('EventName', eventName);
    }

    if (masterCode !== null) {
      params = params.set('MasterCode', masterCode);
    }

    if (severityLevel !== null) {
      params = params.set('SeverityLevel', severityLevel); // fixed spelling from "SeverityLavel"
    }

    if (sourceSystem !== null) {
      params = params.set('SourceSystem', sourceSystem); 
    }

    if (targetSystem !== null) {
      params = params.set('TargetSystem', targetSystem); 
    }

    return this.http.get<any>(url, { params }).pipe(
      catchError(this.handleError)
    );
  }

  getErrorsCount(): Observable<number> {   
    const url = `${environment.apiConfig.api}${this.errorsCountRoute}`;
    return this.http.get<number>(url).pipe(
      catchError(this.handleError)
    );
  }

    // POST request method
  upsertEvent(body: any): Observable<EventMonitoring> {
    const url = `${environment.apiConfig.api}${this.upsertEventRoute}`;
    return this.http.post<EventMonitoring>(url, body);
  }
}